import { render } from "./ImagesCarousel.vue?vue&type=template&id=58525148&scoped=true&ts=true"
import script from "./ImagesCarousel.vue?vue&type=script&lang=ts"
export * from "./ImagesCarousel.vue?vue&type=script&lang=ts"

import "./ImagesCarousel.vue?vue&type=style&index=0&id=58525148&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58525148"]])

export default __exports__